<template>
    <div id="app" class="wrapper" style="min-width:320px">
        <div id="header" class="header">
            <div id="header_left" class="header_left">
                <img src="./images/logos/NWTULogoTransparent300x291.png" class="img-fit">
            </div>
            <div id="header_center" class="header_center">
                <img src="./images/logos/NWTUAnmeldeSystemTransparent300x78.png" class="img-fit">
            </div>
            <div id="header_right" class="header_right">
                <img src="./images/logos/NWTULogoTransparent300x291.png" class="img-fit">
            </div>
        </div>
        <div id="menue" v-if="visibleMenue" class="menue" style="min-width: 320px; display: flex; justify-content:flex-start">
            <kendo-menu :items="menuItems" :open-on-click="true" @select="onSelect"></kendo-menu>
            <div>{{ $t('menu.user.user') }}{{ benutzerHeaderString }}</div>
        </div>
        <div id="content">
            <div v-if="!menuClicked" id="Willkommen" class="welcome_message">
                <h2>{{ $t('menu.welcomemessage.welcomemessage') }}</h2>
                <img src="./images/logos/NWTULogoTransparent300x291.png" style="align-content:center">
                <br />
                <h3 v-if="visibleDialog === false">{{ $t('menu.welcomemessage.Hint') }}</h3>
            </div>
            <br />
            <router-view>

            </router-view>
        </div>
        <div id="footer" class="footer">
            <div id="footer_left" class="footer_left">
                <img src="./images/pics/flag-korea-germany70x70.png" class="img-fit">
            </div>
            <div id="footer_center" class="footer_center">
                <table border="0">
                    <tr>
                        <td>
                            <strong>&copy; Nordrhein-Westf&auml;lische Taekwondo Union e.V.</strong>
                        </td>
                    </tr>
                </table>
            </div>
            <div id="footer_right" class="footer_right">
                <img src="./images/pics/flag-germany-korea70x70.png" class="img-fit">
            </div>
        </div>
        <k-dialog v-if="visibleDialog" :title="$t('splashDialog.title')" :closeIcon="false">
            <div style="white-space: nowrap;text-align:end">
                <button v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language)" class="languageButton">
                    <flag :iso="entry.flag" v-bind:squared=false />
                    <!--{{entry.title}}-->
                </button>
            </div>
            <fieldset>
                <legend>{{ $t('splashDialog.registration') }}</legend>
                <div class="mb-3">
                    <k-input :name="'username'"
                             :style='{ width: "100%" }'
                             :label="$t('splashDialog.username')"
                             :pattern="'^[0-9]*$'"
                             :min-length="1"
                             v-model="user"
                             :required="true">
                    </k-input>
                </div>
                <div class="mb-3">
                    <k-input @keyup.enter="onSubmitClick"
                             :name="$t('splashDialog.password')"
                             type="password"
                             :style="{ width: '100%' }"
                             :label="'Passwort'"
                             v-model="password"
                             :required="true"
                             :min-length="4"
                             :max-length="20" />
                </div>
            </fieldset>
            <div id="Buttons">
                <kbutton @click="onSubmitClick" class="k-button">{{ $t('splashDialog.login') }}</kbutton>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <kbutton @click="onSubmitRegistrierenClick" class="k-button">{{ $t('splashDialog.register') }}</kbutton>
            </div>
            <br />
            <div id="Links" style="text-align:center;">
                <a href="https://nas.nwtu.eu/DatenschutzImpressum.html" target="_blank">{{ $t('splashDialog.privacyimprint') }}</a>
            </div>
        </k-dialog>
        <NotificationGroup :style="{
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            'align-items': 'flex-start'
            }">
            <Fade :appear="success">
                <Notification v-if="success" :type="{ style: 'success', icon: true }">
                    <span>{{ $t('splashDialog.NotificationAccessSuccess') }}</span>
                </Notification>
            </Fade>
            <Fade :appear="error">
                <Notification v-if="error" :type="{ style: 'error', icon: true }">
                    <span>{{ $t('splashDialog.NotificationAccessError') }}</span>
                </Notification>
            </Fade>
        </NotificationGroup>
        <window v-if="visibleWindow"
                :title="$t('registerDialog.title')"
                :close-button="() => null"
                :maximize-button="() => null"
                :minimize-button="() => null"
                @close="toggleDialogWindow"
                :initial-height="640"
                :initial-width="410">
            <fieldset>
                <legend>{{ $t('registerDialog.GroupDataCollection') }}</legend>

                <label class="k-form-field">
                    <span>{{ $t('registerDialog.labelName') }}</span>
                    <k-input v-model="regNachname"
                             :pattern="'[A-Za-z]+'"
                             :minlength="2"
                             :required="true"
                             :placeholder="$t('registerDialog.labelNamePlaceholder')" />
                </label>
                <br />
                <br />
                <label class="k-form-field">
                    <span>{{ $t('registerDialog.labelFirstname') }}</span>
                    <k-input v-model="regVorname"
                             :pattern="'[A-Za-z]+'"
                             :minlength="2"
                             :required="true"
                             :placeholder="$t('registerDialog.labelFirstnamePlaceholder')" />
                </label>
                <br />
                <br />
                <label class="k-form-field">
                    <span>{{ $t('registerDialog.labelEmail') }}</span>
                    <k-input v-model="regEMail"
                             :type="'email'"
                             :required='true'
                             :placeholder="$t('registerDialog.labelEmailPlaceholder')" />
                </label>
                <br />
                <br />
                <label class="k-form-field">
                    <span>{{ $t('registerDialog.labelEmailRepeat') }}</span>
                    <k-input v-model="regEMailWiederholen"
                             :type="'email'"
                             :required='true'
                             :placeholder="$t('registerDialog.labelEmailRepeatPlaceholder')" />
                </label>
                <br />
                <br />
                <label class="k-form-field">
                    <span>{{ $t('registerDialog.labelClub') }}</span>
                    <combobox :style="{ width: '340px' }"
                              :data-items="comboDataVerein"
                              :text-field="'bezeichnung'"
                              :data-item-key="'prim'"
                              :value-field="'prim'"
                              :value-primitive="true"
                              :filterable="true"
                              @filterchange="filterChange"
                              @change="handleChangeVerein"
                              :value="selectedPrimVerein"
                              :placeholder="$t('registerDialog.labelClubPlaceholder')">
                    </combobox>
                </label>
                <br />
                <br />
                <label v-if="visibleBemerkung" class="k-form-field">
                    <span v-if="visibleBemerkung">{{ $t('registerDialog.labelRemark') }}</span>
                    <k-input v-if="visibleBemerkung" v-model="regBemerkung" :placeholder="$t('registerDialog.labelRemarkPlaceholder')" />
                </label>
            </fieldset>
            <br />
            <fieldset>
                <legend>{{ $t('registerDialog.GroupDataDescription') }}</legend>
                <span>{{ $t('registerDialog.GroupDataDescriptionDetail') }}</span>
            </fieldset>
            <br />
            <div class="text-right">
                <kbutton @click="onSubmitRegistrierungAbsendenClick">{{ $t('registerDialog.ButtonSubmit') }}</kbutton>
                &nbsp;
                <kbutton @click="toggleDialogWindow">{{ $t('registerDialog.ButtonCancel') }}</kbutton>
            </div>
            <NotificationGroup :style="{
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            'align-items': 'flex-start'
            }">
                <Fade :appear="successRegistrierung">
                    <Notification v-if="successRegistrierung" :type="{ style: 'success', icon: true }">
                        <span>{{ $t('registerDialog.NotificationRegisterSuccess') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorRegistrierung">
                    <Notification v-if="errorRegistrierung" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('registerDialog.NotificationRegisterError') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorRegistrierungPflichtfelder">
                    <Notification v-if="errorRegistrierungPflichtfelder" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('registerDialog.NotificationRegisterErrorMandatoryFields') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorRegistrierungEMailUngleich">
                    <Notification v-if="errorRegistrierungEMailUngleich" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('registerDialog.NotificationRegisterErrorEMailUnequal') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorRegistrierungEMailFormatFalsch">
                    <Notification v-if="errorRegistrierungEMailFormatFalsch" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('registerDialog.NotificationRegisterErrorEMailFormat') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorRegistrierungEMailBereitsVorhanden">
                    <Notification v-if="errorRegistrierungEMailBereitsVorhanden" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('registerDialog.NotificationRegisterErrorEMailDuplicate') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="success">
                    <Notification v-if="success" :type="{ style: 'success', icon: true }">
                        <span>{{ $t('splashDialog.NotificationAccessSuccess') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="error">
                    <Notification v-if="error" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('splashDialog.NotificationAccessError') }}</span>
                    </Notification>
                </Fade>
            </NotificationGroup>
        </window>
    </div>
</template>

<script>
    import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
    import { Window } from '@progress/kendo-vue-dialogs';
    import { Input } from '@progress/kendo-vue-inputs';
    import { Button } from '@progress/kendo-vue-buttons';
    import { ComboBox } from '@progress/kendo-vue-dropdowns';
    import sha512 from 'crypto-js/sha512';
    import axios from 'axios';
    import config from "@/appdata/config.json";
    import '@progress/kendo-ui';
    import '@progress/kendo-theme-default/dist/all.css';
    import { Menu } from "@progress/kendo-vue-layout";
    import Vue from 'vue'
    import VueRouter from 'vue-router'
    import Home from '@/components/Home.vue';
    import LocaleLink from '@/components/LocaleLink.vue';
    import SDVereine from '@/components/SDVereine.vue';
    import SDBenutzer from '@/components/SDBenutzer.vue';
    import SDParaklassen from '@/components/SDParaklassen.vue';
    import Sportlerverwaltung from '@/components/Sportlerverwaltung.vue';
    import SportlerverwaltungVerein from '@/components/SportlerverwaltungVerein.vue';
    import Turnieranmeldung from '@/components/Turnieranmeldung.vue';
    import store from '@/store/store.js';
    import { EventBus } from '@/classes/eventBus.js';
    import { Fade } from '@progress/kendo-vue-animation';
    import { Notification, NotificationGroup } from '@progress/kendo-vue-notification';
    import { filterBy } from '@progress/kendo-data-query';

    Vue.use(VueRouter)

    export default {
        components: {
            'k-dialog': Dialog,
            'dialog-actions-bar': DialogActionsBar,
            'window': Window,
            'combobox': ComboBox,
            'kbutton': Button,
            'k-input': Input,
            'kendo-menu': Menu,
            Fade,
            Notification,
            NotificationGroup,
            Home, LocaleLink, Sportlerverwaltung, SportlerverwaltungVerein, Turnieranmeldung, SDVereine, SDBenutzer, SDParaklassen, store,
        },
        name: 'Home',
        props: {

        },
        computed: {
            menuItems() {
                if (this.istAdmin === true) {
                    return this.itemsAdministrator;
                } else {
                    return this.itemsBenutzer;
                }
            },
            itemsAdministrator() {
                return [
                    {
                        text: "Menu",
                        icon: "menu",
                        items: [
                            {
                                text: "Administration",
                                icon: "saturation",
                                cssClass: 'subitems',
                                items: [
                                    {
                                        text: this.$t('menu.userauthorisation.userauthorisation'),
                                        icon: "accessibility",
                                        cssClass: 'subitems',
                                        data: {
                                            path: "/Benutzerautorisierung"
                                        }
                                    },
                                    {
                                        text: this.$t('menu.labelprint.labelprint'),
                                        icon: "js",
                                        cssClass: 'subitems',
                                        data: {
                                            path: "/Etikettendruck"
                                        }
                                    },
                                    {
                                        text: this.$t('menu.startsperclub.startsperclub'),
                                        icon: "tell-a-friend-box",
                                        cssClass: 'subitems',
                                        data: {
                                            path: "/StartsJeVerein"
                                        }
                                    },
                                    {
                                        text: this.$t('menu.userMasterData.userMasterData'),
                                        icon: "user",
                                        cssClass: 'subitems',
                                        data: {
                                            path: "/SDBenutzer"
                                        }
                                    },
                                    {
                                        text: this.$t('menu.athletemanagement.athletemanagementAdmin'),
                                        icon: "myspace",
                                        cssClass: 'subitems',
                                        data: {
                                            path: "/Sportlerverwaltung"
                                        }
                                    },
                                    {
                                        text: this.$t('menu.clubMasterData.clubMasterData'),
                                        icon: "login",
                                        cssClass: 'subitems',
                                        data: {
                                            path: "/SDVereine"
                                        }
                                    },
                           
                        ]
                            },
                            {
                                text: this.$t('menu.athletemanagement.athletemanagement'),
                                icon: "myspace",
                                cssClass: 'subitems',
                                data: {
                                    path: "/SportlerverwaltungVerein"
                                }
                            },
                            {
                                text: this.$t('menu.athletereleases.athletereleases'),
                                icon: "share",
                                cssClass: 'subitems',
                                data: {
                                    path: "/Sportlerfreigaben"
                                }
                            },
                            {
                                text: this.$t('menu.pairsTeams.pairsTeams'),
                                icon: "tell-a-friend",
                                cssClass: 'subitems',
                                data: {
                                    path: "/PaareTeams"
                                }
                            },
                            {
                                text: this.$t('menu.tournamentregistration.tournamentregistration'),
                                icon: "login",
                                cssClass: 'subitems',
                                data: {
                                    path: "/Turnieranmeldung"
                                }
                            },
                            {
                                text: this.$t('menu.tournamentregistrationOverview.tournamentregistrationOverview'),
                                icon: "categorize",
                                cssClass: 'subitems',
                                data: {
                                    path: "/TurnieranmeldungVereinUebersicht"
                                }
                            },
                            {
                                text: this.$t('menu.tournamentregistrationOverviewAll.tournamentregistrationOverviewAll'),
                                icon: "globe-outline",
                                cssClass: 'subitems',
                                data: {
                                    path: "/TurnieranmeldungUebersicht"
                                }
                            },
                            {
                                text: this.$t('menu.startsperclass.startsperclass'),
                                icon: "tell-a-friend",
                                cssClass: 'subitems',
                                data: {
                                    path: "/StartsJeKlasse"
                                }
                            },
                            {
                                text: this.$t('menu.changepassword.changepassword'),
                                icon: "gear",
                                cssClass: 'subitems',
                                data: {
                                    path: "/PasswortAendern"
                                }
                            },
                            {
                                text: this.$t('menu.downloads.downloads'),
                                icon: "arrow-drill",
                                cssClass: 'subitems',
                                data: {
                                    path: "/Downloads"
                                }
                            }
                        ]
                    },
                    {
                        text: "Logout",
                        icon: "logout",
                        data: {
                            path: "/Logout",
                        }
                    }
                ]
            },
            itemsBenutzer() {
                return [
                    {
                        text: "Menu",
                        icon: "menu",
                        items: [
                            {
                                text: this.$t('menu.athletemanagement.athletemanagement'),
                                icon: "myspace",
                                cssClass: 'subitems',
                                data: {
                                    path: "/SportlerverwaltungVerein"
                                }
                            },
                            {
                                text: this.$t('menu.athletereleases.athletereleases'),
                                icon: "share",
                                cssClass: 'subitems',
                                data: {
                                    path: "/Sportlerfreigaben"
                                }
                            },
                            {
                                text: this.$t('menu.pairsTeams.pairsTeams'),
                                icon: "tell-a-friend",
                                cssClass: 'subitems',
                                data: {
                                    path: "/PaareTeams"
                                }
                            },
                            {
                                text: this.$t('menu.tournamentregistration.tournamentregistration'),
                                icon: "login",
                                cssClass: 'subitems',
                                data: {
                                    path: "/Turnieranmeldung"
                                }
                            },
                            {
                                text: this.$t('menu.tournamentregistrationOverview.tournamentregistrationOverview'),
                                icon: "categorize",
                                cssClass: 'subitems',
                                data: {
                                    path: "/TurnieranmeldungVereinUebersicht"
                                }
                            },
                            {
                                text: this.$t('menu.tournamentregistrationOverviewAll.tournamentregistrationOverviewAll'),
                                icon: "globe-outline",
                                cssClass: 'subitems',
                                data: {
                                    path: "/TurnieranmeldungUebersicht"
                                }
                            },
                            {
                                text: this.$t('menu.startsperclass.startsperclass'),
                                icon: "tell-a-friend",
                                cssClass: 'subitems',
                                data: {
                                    path: "/StartsJeKlasse"
                                }
                            },
                            {
                                text: this.$t('menu.changepassword.changepassword'),
                                icon: "gear",
                                cssClass: 'subitems',
                                data: {
                                    path: "/PasswortAendern"
                                }
                            },
                            {
                                text: this.$t('menu.downloads.downloads'),
                                icon: "arrow-drill",
                                cssClass: 'subitems',
                                data: {
                                    path: "/Downloads"
                                }
                            }
                        ]
                    },
                    {
                        text: "Logout",
                        icon: "logout",
                        data: {
                            path: "/Logout",
                        }
                    }
                ]
            }
        },
        data: function () {
            return {
                password: '',
                user: '',
                visibleDialog: true,
                visibleMenue: true,
                visibleWindow: false,
                visibleBemerkung: false,
                selectedPrimVerein: 0,
                comboDataVerein: [],
                baseComboUrl: '',
                regNachname: '',
                regVorname: '',
                regEMail: '',
                regEMailWiederholen: '',
                regBemerkung: '',
                eMailCheck:0,
                prim: 0,
                eMail: 0,
                passwortGeaendert: '',
                name: '',
                vorname: '',
                istAdmin: false,
                primVerein: 0,
                nameVerein: '',
                stadt: '',
                countDown: 30,
                posturlRegistrierung: '',
                posturlMail: '',
                benutzerHeaderString: '',
                dataUsertypeItems: [
                    {
                        label: 'Benutzer',
                        value: 'Benutzer',
                    },
                    {
                        label: 'Administrator',
                        value: 'administrator',
                    }
                ],
                successRegistrierung: false,
                errorRegistrierung: false,
                errorRegistrierungPflichtfelder: false,
                errorRegistrierungEMailUngleich: false,
                errorRegistrierungEMailFormatFalsch: false,
                errorRegistrierungEMailBereitsVorhanden: false,
                success: false,
                error: false,
                languages: [{ flag: 'gb', language: 'en', title: 'English' }, { flag: 'de', language: 'de', title: 'Deutsch' }],
                subjectRegistrierung: '',
                bodyRegistrierung: '',
                subjectAutorisierung: '',
                bodyAutorisierung: '',
                eMailTechnikTeam: 'o.schulz@nwtu.de'
            }
        },
        created() {
            EventBus.$on('getBenutzerHeaderString', () => {
                this.getBenutzerHeaderString();
            })
            this.posturlRegistrierung = config[0].ServiceUrl + config[0].ServiceUrlPort + "/InsertBenutzerRegistrierung"
            this.subjectRegistrierung = 'NWTU Anmelde System - (SRQ) Anfrage zur Abonnentenautorisierung';
            this.subjectAutorisierung = 'NWTU Anmelde System - (AUT) Autorisierung Ihres Benutzerkontos';
        },
        mounted() {
            this.onPageMounted();
        },
        methods: {
            onPageMounted() {
                const current = this.$router.history.current;
                const locale = current.params.lang;
                this.$i18n.locale = locale;
            },
            changeLocale: function (language) {
                this.$i18n.locale = language;
                this.$router.push({ path: '/' + language });
            },
            getDataVereinCombo: function () {
                this.selectedPrimVerein = null;
                this.baseComboUrl = config[0].ServiceUrl + config[0].ServiceUrlPort + "/VereineAuswahlManagement";
                this.comboDataVerein = [];
                const that = this;
                fetch(this.baseComboUrl, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.comboDataVerein = data;
                    });
            },
            handleChangeVerein(event) {
                this.selectedPrimVerein = event.value;
                if (this.selectedPrimVerein === 0) {
                    this.visibleBemerkung = true;
                } else {
                    this.visibleBemerkung = false;
                }
            },
            toggleDialogWindow() {
                this.visibleWindow = false;
            },
            onSelect(e) {
                if (e.item.data.path === "/Logout") {
                    window.location.replace("https://nas.nwtu.eu");
                } else {
                    this.menuClicked = true;
                    const language = this.$i18n.locale;
                    const path = e.item.data.path;
                    const newRoute = "/" + language + path;
                    this.$router.push(newRoute);
                }
            },
            getGeneratedPW() {
                let result = "";
                let charactersVal = "";
                for (var j = 0; j < this.characters.length; j++) {
                    if (this.characters[j].checked) {
                        charactersVal += this.characters[j].value;
                    }
                }
                for (var i = 0; i < this.gLength; i++) {
                    result += charactersVal.charAt(Math.floor(Math.random() * charactersVal.length));
                }
                this.newpassword = result;
            },
            onSubmitClick() {
                const crypted = sha512(this.password).toString();
                axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/LoginCheck', {
                    params: {
                        EMail: this.user,
                        Passwort: crypted
                    }
                })
                    .then((response) => {
                        const loginStatus = response.data[0].checkStatus.toString();
                        if (loginStatus === '1') {
                            this.showNotificationSuccessLoginZugriffGewaehrt();
                            this.getUserData();
                            this.getBenutzerHeaderString();
                            this.visibleDialog = false;
                        } else {
                            this.showNotificationErrorLoginZugriffVerweigert();
                            this.countDownTimer();
                            window.location.replace("https://nas.nwtu.eu");
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                    })
            },
            onSubmitRegistrierungAbsendenClick() {
                if (this.regEMail !== '' && this.regEMailWiederholen !== '' && this.regNachname !== '' && this.regVorname !== '') {
                    //Pr�fung ob E-Mail und E-Mail wiederholen gleich ist
                    if (this.regEMail !== this.regEMailWiederholen) {
                        this.showNotificationErrorRegistrierungEMailUngleich();
                    } else {
                        //Pr�fung E-Mail Format
                        if (this.checkEmail(this.regEMail) === false) {
                            this.showNotificationErrorRegistrierungEMailFormatFalsch();
                        } else {
                            //Gibt es die E-Mail bereits im System?
                            axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/EMailCheck', {
                                params: {
                                    EMail: this.regEMail
                                }
                            })
                                .then((response) => {
                                    this.eMailCheck = response.data[0].eMailCheck;
                                    if (this.eMailCheck === 2) {
                                        //E-Mail noch nicht im System vorhanden
                                        //Zufallszahl f�r Passwort generieren
                                        let random_id = Math.ceil(Math.random() * 1000000)
                                        let random_id_text = random_id.toString();
                                        //Zahl in Passwort umwandeln
                                        const crypted = sha512(random_id_text).toString();
                                        //Insert in DB
                                        const parameters = {
                                            "eMail": this.regEMail,
                                            "name": this.regNachname,
                                            "vorname": this.regVorname,
                                            "refVereine": this.selectedPrimVerein,
                                            "passwort": crypted,
                                            "bemerkung": this.regBemerkung
                                        };
                                        axios.post(this.posturlRegistrierung, parameters)
                                            .then((response) => {
                                                console.log("----------> success", response);
                                                //E-Mails versenden - An neuen Benutzer
                                                //Mailtext aufbereiten
                                                this.bodyRegistrierung = '(SRQ) Anfrage zur Abonnentenautorisierung (for english version, please see below)<br /><br />'
                                                    + 'Hallo ' + this.regVorname + ', <br /><br />'
                                                    + 'Ihre Registrierung beim NWTU Nameldesystem NAS wartet auf die Genehmigung. Ihre Zugangsdaten lauten wie folgt:<br /><br />'
                                                    + 'Benutzer: ' + this.regEMail + '<br />'
                                                    + 'Passwort: ' + random_id_text + '<br /><br />'
                                                    + 'Sobald Sie autorisiert sind, können Sie sich mit diesen Zugangsdaten am System anmelden.<br />'
                                                    + 'Bitte ändern Sie Ihr Passwort sofort nach dem Login!<br /><br />'
                                                    + 'Turnier Organisation<br />'
                                                    + '<p>---------------------------------------------------</p>'
                                                    + '(SRQ) Subscriber Authorization request<br /><br />'
                                                    + 'Hello ' + this.regVorname + ', <br /><br />'
                                                    + 'Your registration with NWTU Anmeldesystem NAS is waiting to be approved. Your login details are as follows:<br /><br />'
                                                    + 'User: ' + this.regEMail + '<br />'
                                                    + 'Password: ' + random_id_text + '<br /><br />'
                                                    + 'Once you have been authorized, you can log in to the system with these credentials.<br />'
                                                    + 'Please change your password immediately after logging in!<br /><br />'
                                                    + 'Tournament organization<br />';
                                                //E-Mail Post
                                                this.posturlMail = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Mail?receiver=" + this.regEMail + "&title=" + this.subjectRegistrierung + "&body=" + this.bodyRegistrierung + "&isHtml=true"
                                                axios.post(this.posturlMail)
                                                    .then((response) => {
                                                        console.log("----------> successMailRegistrierung", response);
                                                    })
                                                    .catch((error) => {
                                                        console.log("---------> errorMailRegistrierung", error);
                                                    });
                                                //E-Mails versenden - An Technik Team
                                                //Mailtext aufbereiten
                                                this.bodyAutorisierung = 'Neuer Benutzer bittet um Autorisierung. <br /><br />'
                                                    + 'Daten:<br />'
                                                    + 'Benutzer: ' + this.regEMail + '<br />'
                                                    + 'Name: ' + this.regNachname + '<br />'
                                                    + 'Vornme: ' + this.regVorname + '<br /><br />'
                                                    + 'Turnier Organisation';
                                                //E-Mail Post
                                                this.posturlMail = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Mail?receiver=" + this.eMailTechnikTeam + "&title=" + this.subjectAutorisierung + "&body=" + this.bodyAutorisierung + "&isHtml=true"
                                                axios.post(this.posturlMail)
                                                    .then((response) => {
                                                        console.log("----------> successMailAutorisierung", response);
                                                    })
                                                    .catch((error) => {
                                                        console.log("---------> errorMailAutorisierung", error);
                                                    });
                                                //Anzeige setzen und Fenster schlie�en
                                                this.showNotificationSuccessRegistrierung();
                                                setTimeout(() => {
                                                    this.visibleWindow = false;
                                                }, 3000);
                                            })
                                            .catch((error) => {
                                                console.log("---------> error", error);
                                                this.showNotificationErrorRegistrierung();
                                            });
                                    } else {
                                        //Meldung, dass E-Mail bereits vorhanden ist
                                        this.showNotificationErrorRegistrierungEMailBereitsVorhanden();
                                    }
                                })
                                .catch(error => {
                                    console.log(error)
                                    this.errored = true
                                })
                        }
                    }
                } else {
                    this.showNotificationErrorRegistrierungPflichtfelder();
                }
            },
            onSubmitRegistrierenClick() {
                this.getDataVereinCombo();
                this.visibleWindow = true;
            },
            getUserData() {
                const crypted = sha512(this.password).toString();
                axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/LoginDetails', {
                    params: {
                        EMail: this.user,
                        Passwort: crypted
                    }
                })
                    .then((response) => {
                        this.prim = response.data[0].primBenutzer;
                        this.eMail = response.data[0].eMail;
                        this.name = response.data[0].name;
                        this.vorname = response.data[0].vorname;
                        this.istAdmin = response.data[0].istAdmin;
                        this.primVerein = response.data[0].primVerein;
                        this.nameVerein = response.data[0].nameVerein;
                        this.stadt = response.data[0].stadt;
                        //�bertragung in den Store
                        store.refBenutzer = this.prim;
                        store.eMail = this.eMail;
                        store.name = this.name;
                        store.vorname = this.vorname;
                        store.istAdmin = this.istAdmin;
                        store.primVerein = this.primVerein;
                        store.nameVerein = this.nameVerein;
                        store.stadt = this.stadt;
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                    })
            },
            getBenutzerHeaderString() {
                axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/BenutzerHeaderString', {
                    params: {
                        EMail: this.user
                    }
                })
                    .then((response) => {
                        this.benutzerHeaderString = response.data[0].benutzerHeaderString;
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                    })
            },
            filterChange(event) {
                this.comboDataVerein = this.filterData(event.filter);
            },
            filterData(filter) {
                const data = this.comboDataVerein.slice();
                return filterBy(data, filter);
            },
            checkEmail: function (email) {
                // eslint-disable-next-line
                const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                const result = reg.test(email);
                return result
            },
            showNotificationSuccessLoginZugriffGewaehrt() {
                /*Meldung anzeigen*/
                this.success = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.success = false;
                }, 3000); 
            },
            showNotificationErrorLoginZugriffVerweigert() {
                /*Meldung anzeigen*/
                this.error = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.error = false;
                }, 3000); 
            },
            showNotificationSuccessRegistrierung() {
                /*Meldung anzeigen*/
                this.successRegistrierung = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.successRegistrierung = false;
                }, 3000);
            },
            showNotificationErrorRegistrierung() {
                /*Meldung anzeigen*/
                this.errorRegistrierung = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorRegistrierung = false;
                }, 3000);
            },
            showNotificationErrorRegistrierungPflichtfelder() {
                /*Meldung anzeigen*/
                this.errorRegistrierungPflichtfelder = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorRegistrierungPflichtfelder = false;
                }, 3000);
            },
            showNotificationErrorRegistrierungEMailUngleich() {
                /*Meldung anzeigen*/
                this.errorRegistrierungEMailUngleich = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorRegistrierungEMailUngleich = false;
                }, 3000);
            },
            showNotificationErrorRegistrierungEMailFormatFalsch() {
                /*Meldung anzeigen*/
                this.errorRegistrierungEMailFormatFalsch = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorRegistrierungEMailFormatFalsch = false;
                }, 3000);
            },
            showNotificationErrorRegistrierungEMailBereitsVorhanden() {
                /*Meldung anzeigen*/
                this.errorRegistrierungEMailBereitsVorhanden = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorRegistrierungEMailBereitsVorhanden = false;
                }, 3000);
            },
            countDownTimer() {
                if (this.countDown > 0) {
                    setTimeout(() => {
                        this.countDown -= 1;
                        this.countDownTimer();
                    }, 1000)
                }
            },
            CorsPolicies: {
                Default: {
                    Origins: "http://localhost:*,https://localhost:*,http://nwtu.eu:*,https://nwtu.eu:*,https://nas.nwtu.eu:*,https://msnas.nwtu.eu:*,https://192.168.0.101:*",
                    Methods: "AllowAnyMethod,PUT,GET,PATCH,DELETE,OPTIONS,POST",
                    Headers: "AllowAnyHeader,Authorization,Content-Type,Prefer,X-CUSTOM-HEADER",
                    AllowCredentials: true,
                    DisallowCredentials: false
                }
            }
        }
    };
</script>

 Add "scoped" attribute to limit CSS to this component only 
<style scoped>
    li a {
        text-decoration: none;
    }

    @import './css/main.css';
</style>

